import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslationService } from '@cbcore/services/translation/translation.service';
import { UtilService } from '@cbcore/services/utils/utils/utils.service';
import { MenuComponent, DesktopFixedMenuComponent } from '@cbui/public_api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, RouterOutlet, MenuComponent, DesktopFixedMenuComponent]
})
export class AppComponent implements OnInit {
  public ready: boolean | undefined;

  constructor(
    private _translationService: TranslationService,
    private utilsService: UtilService,
  ) {
    this.utilsService.setTheme(false, 'light');
  }

  ngOnInit() {
    this._translationService.ready().subscribe(
      (_data: any) => {
        this.ready = true
      }
    );
  }
}
